import React from 'react'

export default function ImageWrapper({...props}){
    return(
        <div {...props}>
            <img src={props.src} alt={props.alt} className='w-full h-full object-fit rounded-[inherit]'/>
        </div>
    )
}